import { ITemplateScope } from "AngularFormly";
import { IRowCommandEventArgs } from "../../../../../records/grids/controller";
import {
  SelectMachineModalService,
  vsServiceName as selectMachineModalServiceName,
} from "../../../components/selectMachineModal";
import {
  GridConfiguration,
  RecordGridViewService,
  vsServiceName as RecordGridViewServiceName,
} from "../../../../../records/views/recordGridView";
import { IQService } from "angular";
import {
  ColumnDefinitionService,
  vsName as ColumnDefinitionServiceName,
} from "../../../../../records/grids/columns/columnDefinitionService";
import { MachineConfigurationView } from "../../../models/machineConfiguration";

interface FormlyTypeSelectMachineScope extends ITemplateScope {
  openMachineModal: () => void;
}

export class FormlyTypeSelectMachineController {
  static $inject = [
    selectMachineModalServiceName,
    "$scope",
    RecordGridViewServiceName,
    "$q",
    ColumnDefinitionServiceName,
  ];

  private modalService: angular.ui.bootstrap.IModalInstanceService | undefined;
  constructor(
    private readonly selectMachineModalService: SelectMachineModalService,
    private readonly $scope: FormlyTypeSelectMachineScope,
    private readonly recordGridViewService: RecordGridViewService,
    private readonly $q: IQService,
    private readonly columnDefinitionService: ColumnDefinitionService
  ) {
    this.$scope.openMachineModal = () => this.openMachineModal();
  }

  openMachineModal() {
    const gridConfiguration: GridConfiguration | undefined =
      this.recordGridViewService.getGridConfiguration("machineConfiguration");
    if (!gridConfiguration) {
      throw new Error(
        "Must have machineConfiguration registered with recordGridViewService"
      );
    }

    gridConfiguration.columns = [
      this.columnDefinitionService.getCommandColDef({
        headerName: "select",
        iconClass: "fa fa-plus-circle text-primary",
        name: "select",
        width: 20,
      }),
      ...(gridConfiguration?.columns ?? []),
    ];

    gridConfiguration.onItemCommand = (args: IRowCommandEventArgs<any>) => {
      const { commandName, data: machineConfigurationView } = args;
      if (commandName != "select") {
        return this.$q.when();
      }
      this.prepareMachineConfigurationView(machineConfigurationView);
      const model = this.$scope.model ?? {};
      model[this.$scope.options.key] = machineConfigurationView;
      this.modalService?.close();
      return this.$q.when();
    };

    this.modalService = this.selectMachineModalService.openModal({
      defaultQuery: { CurrentConfiguration: true },
      gridConfiguration,
    });
  }
  prepareMachineConfigurationView(
    machineConfigurationView: MachineConfigurationView
  ) {
    const { Id: machineConfigurationId, MachineId: machineId } =
      machineConfigurationView;
    machineConfigurationView.Id = machineId;
    machineConfigurationView.MachineConfigurationId = machineConfigurationId;
  }
}
